import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import Modal from '@amzn/awsui-components-console/modal';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { NOT_AVAILABLE } from '../constants';

interface StringVersionViewModalProps {
  visible: boolean;
  stringId: string;
  version: number;
  /** This version's source text, already fetched by the panel. */
  sourceText: string;
  /** This version's context note, already fetched by the panel. */
  contextNote: string;
  onDismiss: () => void;
}

/**
 * One version's snapshot of a single string.
 *
 * Presentational only: the values are passed in from the snapshot the panel
 * already holds, so opening this modal fetches nothing. The group page's
 * `ViewVersionModal` is not reused because it lists a whole group's strings and
 * fetches to do it.
 */
const StringVersionViewModal: React.FC<StringVersionViewModalProps> = ({
  visible,
  stringId,
  version,
  sourceText,
  contextNote,
  onDismiss,
}) => (
  <Modal
    visible={visible}
    onDismiss={onDismiss}
    size="medium"
    data-testid="string-view-modal"
    closeAriaLabel="Close version snapshot"
    header={`View: ${stringId} at v${version}`}
  >
    <SpaceBetween size="m">
      <Box color="text-body-secondary" fontSize="body-s">
        Snapshot of string at this version
      </Box>
      <div>
        <Box variant="awsui-key-label">Source text</Box>
        <Box variant="p" data-testid="string-view-source-text">
          {sourceText || NOT_AVAILABLE}
        </Box>
      </div>
      <div>
        <Box variant="awsui-key-label">Context note</Box>
        <Box variant="p" data-testid="string-view-context-note">
          {contextNote || NOT_AVAILABLE}
        </Box>
      </div>
    </SpaceBetween>
  </Modal>
);

export default StringVersionViewModal;
